import { TreatmentAssignmentRule } from './treatment-assignment-rule.model';

export interface TreatmentAssignmentRuleMatch {
    readonly treatmentId: string;
    readonly rule?: TreatmentAssignmentRule | null;
    readonly score: number;
    /**
     * Rules tied with the winner on score and conditions. Non-empty means the configuration is
     * ambiguous and the tie is being broken by modified date.
     */
    readonly conflictingRuleIds: readonly number[];
}
